import React from 'react';
import type { ConciergeProductV2Detail } from '../../types';
import { StarRating } from './StarRating';
import { CHIP_BG, INK } from './constants';

/** Compact a large count, e.g. 16225 -> "16.2K", 100000 -> "100K". */
function compactCount(value: number): string {
  if (value >= 1_000_000) {
    const next = value / 1_000_000;
    return `${Number.isInteger(next) ? next.toFixed(0) : next.toFixed(1)}M`;
  }
  if (value >= 1_000) {
    const next = value / 1_000;
    return `${Number.isInteger(next) ? next.toFixed(0) : next.toFixed(1)}K`;
  }
  return value.toString();
}

export function RatingRow({ detail, fallbackUnitsSold }: { detail: ConciergeProductV2Detail; fallbackUnitsSold?: number }) {
  const rating = detail.reviewsRating || detail.reviewsAverageRating || 0;
  const reviewCount = detail.reviewsCount || 0;
  // The detail endpoint strips `unitsSold`, so fall back to the count the
  // carousel card handed off when opening the panel.
  const soldCount = detail.unitsSold || fallbackUnitsSold || 0;
  if (rating <= 0 && soldCount <= 0) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, minHeight: 24 }}>
      {rating > 0 && (
        <>
          <StarRating rating={rating} />
          <span style={{ fontSize: 12, fontWeight: 500, lineHeight: '16px', whiteSpace: 'nowrap', color: INK }}>
            {Math.round(rating * 10) / 10}
            {reviewCount > 0 && <> from {reviewCount.toLocaleString()} reviews</>}
          </span>
        </>
      )}
      {soldCount > 0 && (
        <span
          style={{
            background: CHIP_BG,
            borderRadius: 100,
            padding: '2px 8px',
            fontSize: 10,
            fontWeight: 500,
            lineHeight: '20px',
            whiteSpace: 'nowrap',
            color: INK,
          }}
        >
          {compactCount(soldCount)}+ sold
        </span>
      )}
    </div>
  );
}
